import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { i18nTranslate } from 'src/utils'
import DatePicker from 'react-datepicker'
import { Row, Col, Button, Form, Container } from 'react-bootstrap'
import {
  IoIosAddCircleOutline as PlusIcon,
  IoIosCloseCircleOutline as CloseIcon,
} from 'react-icons/io'
import { MdDateRange as DatePickerIcon } from 'react-icons/md'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import { CommonForm } from 'src/views/components'
import { CostCenterState } from './state'
import { formInput } from './formInput'
import './styles.scss'

const constructStyle = {
  formRowClassName: 'mt-2',
}

@observer
class CreateCostCenter extends React.Component {
  @observable costCenterArray = this.props?.data?.budgets || []
  @observable costCenterStatus = this.props?.data?.status || ''
  @observable isDeleteCostCenter = false

  costCenterState = new CostCenterState()

  constructor(props) {
    super(props)
    this.budgetForm = {}
    this.costCenterName = {}
    this.costCenterDescription = {}
  }

  // Disabled form + remove icon + function
  handleRemoveBudget = index => {
    this.costCenterArray.splice(index, 1)
  }
  renderRemoveButton = () => {
    return (
      <Button
        type="submit"
        variant="light"
        className="close-icon h-auto border-white bg-white p-0 text-primary">
        <CloseIcon
          className="close-icon h-auto"
          data-testid="qa-budget-cancel-icon"
        />
      </Button>
    )
  }
  renderDisabledForms = (data, index) => {
    return (
      <CommonForm
        key={`disabledCostCenterForm-${index}`}
        formTypeJson={formInput(data, true)}
        SubmitButtonProps={this.renderRemoveButton}
        onSubmit={() => this.handleRemoveBudget(index)}
        classNameValue={constructStyle}
      />
    )
  }
  validateOnSubmit = checkAllForm => {
    const isBudgetValid = this.costCenterState.validateBudget()
    const isDatesValid = this.costCenterState.validateBudgetDate(
      this.costCenterArray
    )
    const isCostCenterNameValid =
      checkAllForm &&
      this.costCenterState.validateCostCenterName(this.costCenterName.value)

    return {
      isBudgetValid,
      isDatesValid,
      isCostCenterNameValid,
    }
  }

  createCostCenter = isFromSave => {
    const data = {
      budgets: this.costCenterArray,
      name: this.costCenterName.value,
      status: this.costCenterStatus ? this.costCenterStatus : 'Active',
    }
    if (isFromSave) {
      data.costCenterId = this.props?.data?.id || ''
      this.props.handleVisibility({ isOpen: false })
    } else {
      // Make the create cost center call here
      this.costCenterName.value = ''
      this.costCenterDescription.value = ''
    }
    this.props.handleCostCenterDetails(data)
    this.costCenterArray = this.props?.data?.budgets || []
  }
  handleCreateCostCenter = isFromSave => {
    const { isBudgetValid, isDatesValid, isCostCenterNameValid } =
      this.validateOnSubmit(true)
    if (isCostCenterNameValid) {
      if (isBudgetValid && isDatesValid) {
        this.costCenterArray.push(this.costCenterState.costCenterLastObject)
        this.costCenterState.costCenterLastObject = {}
        this.budgetForm.value = this.costCenterState.currencyCode
      }
      const isAllFieldsEmpty =
        (!isBudgetValid && !isDatesValid) || (isBudgetValid && isDatesValid)
      if (this.costCenterArray.length > 0 && isAllFieldsEmpty) {
        this.costCenterState.errorMessages = {}
        this.createCostCenter(isFromSave)
      }
    }
  }
  handleAddBudget = event => {
    event && event.preventDefault()
    const { isBudgetValid, isDatesValid } = this.validateOnSubmit()

    if (isBudgetValid && isDatesValid) {
      this.costCenterArray.push(this.costCenterState.costCenterLastObject)
      this.costCenterState.costCenterLastObject = {}
      this.budgetForm.value = this.costCenterState.currencyCode
    }
  }

  renderDescription = () => {
    return (
      <Row noGutters className="m-0 pt-2">
        <Form.Label data-testid="qa-description">
          {i18nTranslate('myaccount.description', 'Description')}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={i18nTranslate('myaccount.description', 'Description')}
          ref={node => (this.costCenterDescription = node)}
          data-testid="qa-cost-description-input"
        />
      </Row>
    )
  }
  renderDeleteCostButton = () => {
    const costCenterId = this.props?.data?.id || ''
    return (
      <Row
        noGutters
        className="cost-confirmation-wrapper mt-2 mt-md-3 justify-content-start justify-content-md-end">
        <Col lg={4} md={4} className="px-2">
          <span className="text-danger  p-2" data-testid="qa-cost-team">
            {i18nTranslate(
              'deleteCostCenter.text',
              'Are you sure you want to delete this cost center'
            )}
            ?
          </span>
        </Col>
        <Col lg={4} md={4} className="px-2">
          <Button
            variant="primary"
            className="remove-cost-confirmation w-100 my-2"
            onClick={() => {
              this.props.handleDeleteCostCenter(costCenterId)
            }}
            data-testid="qa-delete-cost">
            {i18nTranslate('removeCost.Delete', 'Delete')}
          </Button>
        </Col>
        <Col className="px-2" lg={4} md={4}>
          <Button
            variant="outline-primary"
            className="remove-cost-confirmation w-100 ml-md-2 my-2"
            onClick={() => {
              this.isDeleteCostCenter = false
            }}
            data-testid="qa-cancel-cost">
            {i18nTranslate('removeCost.Cancel', 'Cancel')}
          </Button>
        </Col>
      </Row>
    )
  }

  renderSubmitButton = () => {
    const { isEditForm, teamData = [] } = this.props
    const costCenterId = this.props?.data?.id || ''
    const isCostCenterWithTeam = teamData.find(teamCostcenter => {
      return costCenterId === teamCostcenter.costCentreId
    })
    const isDisable = isCostCenterWithTeam !== undefined ? true : false
    if (isEditForm) {
      return (
        <Container className="wrap-delete-container">
          {!this.isDeleteCostCenter && (
            <Row lg={12} noGutters className="my-3">
              <Button
                onClick={() => this.handleCreateCostCenter(true)}
                className="col-12 col-md-3"
                variant="primary"
                data-testid="qa-save-changes">
                {i18nTranslate('costcenter.save', 'Save Changes')}
              </Button>
              <Button
                variant="outline-primary"
                className="cancel-button col-12 col-md-3 mt-3 mt-md-0 ml-md-3"
                onClick={() => {
                  this.props.handleVisibility({ isOpen: false })
                }}
                data-testid="qa-cancel-cost-center">
                {i18nTranslate('costcenter.cancel', 'Cancel')}
              </Button>
              <Button
                variant="light"
                onClick={() => {
                  this.isDeleteCostCenter = true
                }}
                disabled={isDisable}
                className="col-12 col-md-4 mt-3 mt-md-0 ml-md-auto border border-light-grey delete-cost-center"
                data-testid="qa-delete-cost-center">
                {i18nTranslate(
                  'costcenter.deleteCostCenter',
                  'Delete Cost Center'
                )}
              </Button>
            </Row>
          )}
        </Container>
      )
    }
    return (
      <React.Fragment>
        {this.renderDescription()}
        <Row noGutters>
          <Button
            onClick={() => this.handleCreateCostCenter()}
            variant="primary"
            className="cost-center-create-button d-flex px-3 py-1 justify-content-center align-items-center mt-3 col-lg-4"
            data-testid="qa-save-cost-center">
            {i18nTranslate('costcenter.create', 'Create')}
          </Button>
          <Button
            onClick={() => this.props.handleCreateCostCenter()}
            variant="outline-dark"
            className="ml-0 ml-lg-3 cost-center-create-button d-flex px-3 py-1 justify-content-center align-items-center mt-3 col-lg-4"
            data-testid="qa-cancel-cost-center">
            {i18nTranslate('costcenter.cancel', 'Cancel')}
          </Button>
        </Row>
      </React.Fragment>
    )
  }
  renderAddButton = () => {
    return (
      <Button
        type="submit"
        variant="light"
        className="plus-icon border-white bg-white p-0 text-primary position-absolute">
        <PlusIcon
          className="plus-icon h-auto"
          data-testid="qa-budget-add-icon"
        />
      </Button>
    )
  }
  renderDatePicker = props => {
    let propValues = {}
    if (props.isStartDate) {
      propValues = {
        label: i18nTranslate('myaccount.costCenterStartDate', 'Start Date *'),
        selectedDate:
          this.costCenterState?.costCenterLastObject?.startDate || '',
        errorMessage: this.costCenterState.errorMessages.errorStartDate || '',
        labelDataTestId: 'qa-start-date',
        inputDataTestId: 'qa-start-date-input',
        invalidDataTestId: 'qa-start-date',
      }
    } else {
      propValues = {
        label: i18nTranslate('myaccount.costCenterEndDate', 'End Date *'),
        selectedDate: this.costCenterState.costCenterLastObject.endDate,
        errorMessage: this.costCenterState.errorMessages.errorEndDate || '',
        labelDataTestId: 'qa-end-date',
        inputDataTestId: 'qa-end-date-input',
        invalidDataTestId: 'qa-end-date',
      }
    }

    const locale = getLocaleCodeFromUrl({
      locationProps: this.props,
      at: 'pathParam',
      defaultLocale: 'en_US',
      isReverseType: true,
    })

    return (
      <>
        <Row
          noGutters
          className={`date-picker position-relative  ${propValues.errorMessage}`}>
          <Form.Label data-testid={propValues.labelDataTestId}>
            {propValues.label}
          </Form.Label>
          <Form.Label data-testid={propValues.inputDataTestId}>
            <DatePicker
              placeholderText={propValues.label}
              className="form-input"
              locale={locale?.split?.('-')?.[0]}
              minDate={new Date()}
              selected={propValues.selectedDate}
              startDate={this.costCenterState.costCenterLastObject.startDate}
              onChange={(date, event) => {
                event.preventDefault()
                this.costCenterState.handleChangeDate(date, props)
              }}
              showDisabledMonthNavigation
            />
            <div className="date-picker-icon-wrap position-absolute">
              <DatePickerIcon className="mb-2" />
            </div>
          </Form.Label>
        </Row>
        <Form.Control.Feedback
          type="invalid"
          data-testid={propValues.invalidDataTestId}>
          {i18nTranslate(
            'myaccount.datePickerErrorMessage',
            'Please select a valid date'
          )}
        </Form.Control.Feedback>
      </>
    )
  }

  renderBudgetForm = () => {
    return (
      <>
        <Form id="myForm" onSubmit={data => this.handleAddBudget(data)}>
          <Form.Row className="budget-form m-0 mt-2">
            <Col className="col-lg-4 col-md-3 col-sm-5 col-12 p-0 pr-2">
              <Form.Label data-testid="qa-budget">
                {i18nTranslate('costcenter.totalBudget', 'Budget *')}
              </Form.Label>
              <Form.Control
                defaultValue={this.costCenterState.currencyCode}
                className={this.costCenterState.errorMessages.totalBudgetError}
                placeholder="Budget*"
                onChange={() =>
                  (this.costCenterState.errorMessages.totalBudgetError = '')
                }
                onBlur={() =>
                  this.costCenterState.handleLastField(this.budgetForm.value)
                }
                ref={node => (this.budgetForm = node)}
                data-testid="qa-budget-input"
              />
              <Form.Control.Feedback
                type="invalid"
                data-testid="qa-invalid-budget">
                Enter the budget amount
              </Form.Control.Feedback>
            </Col>
            <Col className="col-lg-3 col-md-4 col-sm-3 col-5 mt-2 mt-md-0 pl-0">
              {this.renderDatePicker({
                isStartDate: true,
              })}
            </Col>
            <Col className="col-lg-3 col-md-4 col-sm-3 col-5 mt-2 mt-md-0">
              {this.renderDatePicker({
                isEndDate: true,
              })}
            </Col>
            <Col className="position-relative p-1 add-button-cls">
              {this.renderAddButton()}
            </Col>
          </Form.Row>
        </Form>
        {this.renderSubmitButton()}
      </>
    )
  }

  renderStatusOptions = () => {
    const activeTitle = i18nTranslate('myaccount.statusActive', 'Active')
    const expiredTitle = i18nTranslate('myaccount.statusExpired', 'Inactive')
    const options = [
      { label: activeTitle, value: 'Active' },
      { label: expiredTitle, value: 'Inactive' },
    ]
    return options
  }
  renderCostCenterTeamName = () => {
    const { isEditForm = false } = this.props
    const name = this.props?.data?.name

    const options = this.renderStatusOptions()

    return (
      <Row className="m-0" noGutters>
        <Col className="p-0 mr-2">
          <Form.Label data-testid="qa-cost-center-name">
            {i18nTranslate('myaccount.costCenterName', 'Cost Center Name')} *
          </Form.Label>
          <Form.Control
            className={this.costCenterState.errorMessages.errorCostCenter}
            type="text"
            defaultValue={name}
            placeholder={i18nTranslate(
              'myaccount.costCenterName',
              'Cost Center Name'
            )}
            onChange={() =>
              (this.costCenterState.errorMessages.errorCostCenter = '')
            }
            ref={node => (this.costCenterName = node)}
            data-testid="qa-cost-center-input"
          />
          <Form.Control.Feedback
            type="invalid"
            data-testid="qa-invalid-cost-name">
            {i18nTranslate(
              'myaccount.costcenterNameErrorText',
              'Please enter the required field'
            )}
          </Form.Control.Feedback>
        </Col>
        {isEditForm && (
          <Col className="p-0" data-testid="qa-costcenter-status-options">
            <Form.Label>
              {i18nTranslate('myaccount.costcenterstatus', 'Status')}
            </Form.Label>
            <Form.Control
              as="select"
              type="select"
              value={this.costCenterStatus}
              placeholder={i18nTranslate(
                'myaccount.costcenterstatus',
                'Status'
              )}
              onChange={data => {
                this.costCenterStatus = data.target.value
              }}>
              {options.map(x => {
                return (
                  <option
                    value={x.value}
                    label={x.label}
                    data-testid="qa-options"
                    key={x.label}>
                    {x.label}
                  </option>
                )
              })}
            </Form.Control>
          </Col>
        )}
      </Row>
    )
  }
  render() {
    return (
      <>
        {this.renderCostCenterTeamName()}
        {this.costCenterArray &&
          this.costCenterArray.map(this.renderDisabledForms)}
        {this.renderBudgetForm()}
        {this.isDeleteCostCenter && this.renderDeleteCostButton()}
      </>
    )
  }
}
export { CreateCostCenter }
